import InsightTimeline from './InsightTimeline';

export default InsightTimeline;
